import { render, staticRenderFns } from "./appraise.vue?vue&type=template&id=654d5c46&scoped=true"
import script from "./appraise.vue?vue&type=script&lang=js"
export * from "./appraise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654d5c46",
  null
  
)

export default component.exports